import { useId } from 'react';

/**
 * Πεδίο με κουμπί δίπλα του, και **μήνυμα σφάλματος που δεν μετακινεί το κουμπί**.
 *
 * Η προφανής διάταξη —`flex items-end`— έχει ένα ελάττωμα που φαίνεται μόνο όταν
 * εμφανιστεί το μήνυμα: το πεδίο ψηλώνει, η γραμμή ψηλώνει μαζί του, και το κουμπί,
 * στοιχισμένο στο κάτω άκρο, **κατεβαίνει**. Ο χρήστης που πάει να πατήσει «Άντληση
 * στοιχείων» το βρίσκει μετατοπισμένο τη στιγμή ακριβώς που εμφανίζεται το σφάλμα.
 *
 * Εδώ η διάταξη είναι πλέγμα δύο γραμμών: το πεδίο και το κουμπί μοιράζονται την
 * **πρώτη**, και το μήνυμα παίρνει **δική του** δεύτερη γραμμή κάτω από το πεδίο. Ό,τι
 * κι αν κάνει το μήνυμα, η πρώτη γραμμή δεν μεταβάλλεται.
 *
 * **Η σύνδεση με τον αναγνώστη οθόνης δεν χάνεται.** Βγάζοντας το μήνυμα έξω από το
 * `TextField` χάνεται το `aria-describedby` που θα έστηνε μόνο του το HeroUI, οπότε το
 * αναγνωριστικό παράγεται εδώ και δίνεται πίσω στον καλούντα: το πεδίο γράφεται ως
 * συνάρτηση που το δέχεται. Μήνυμα σφάλματος που δεν ανακοινώνεται είναι μήνυμα που
 * δεν υπάρχει για όποιον δεν το βλέπει (ΜΛΑ-11).
 *
 * @param children  Συνάρτηση `({ describedBy }) => πεδίο`.
 * @param action    Το κουμπί, στην πρώτη γραμμή δίπλα στο πεδίο.
 * @param message   Το μήνυμα σφάλματος, ή κενό.
 */
export default function FieldWithAction({ children, action, message = '' }) {
    const messageId = useId();

    return (
        <div className="grid grid-cols-[minmax(0,1fr)_auto] gap-x-2">
            <div className="col-start-1 row-start-1 min-w-0">
                {children({ describedBy: message ? messageId : undefined })}
            </div>

            <div className="col-start-2 row-start-1 self-end">{action}</div>

            {message && (
                <p id={messageId} className="col-start-1 row-start-2 mt-1 text-sm text-danger">
                    {message}
                </p>
            )}
        </div>
    );
}
